module.exports = __webpack_public_path__ + "efb229b5f6bfb3207a01da216192475b.pdf";